import { useQuery } from '@apollo/client';

import { TsrctSupplierContactNamePolicy } from '@/generated/gql/graphql';

import { SUPPLIER_CONTACT_NAME_POLICY_QUERY } from './SupplierContactNamePolicy.gql';

// Undefined means the policy is unknown: the query is still in flight, it failed, or this
// tesseract does not expose the field yet. The UI shows no hint at all in that state rather
// than guessing (BUG-2927, design decision 7) — guessing "strict" would flash "add the contact
// manually" at precisely the users this ticket unblocks.
export const useSupplierContactNamePolicy = (): TsrctSupplierContactNamePolicy | undefined => {
  const { data } = useQuery(SUPPLIER_CONTACT_NAME_POLICY_QUERY, { fetchPolicy: 'cache-first' });
  return data?.tesseract.supplierContactSettings.namePolicy;
};
